import React from "react";
import { MessageCircle } from "lucide-react";
import { useApp, waLink, WA_MSG_EN, WA_MSG_AR } from "@/context/AppContext";

const WhatsAppButton = () => {
  const { lang } = useApp();
  const msg = lang === "ar" ? WA_MSG_AR : WA_MSG_EN;
  return (
    <a
      href={waLink(msg)}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp-button"
      aria-label="WhatsApp"
      className="fixed bottom-6 end-6 z-50 flex items-center justify-center h-14 w-14 rounded-full shadow-2xl transition-transform hover:scale-110"
      style={{ backgroundColor: "#25D366" }}
    >
      <MessageCircle className="h-7 w-7 text-white" fill="white" />
      <span className="absolute inline-flex h-full w-full rounded-full opacity-40 animate-ping" style={{ backgroundColor: "#25D366" }} />
    </a>
  );
};

export default WhatsAppButton;
